// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dash-filters-modal{\n  z-index:20000;\n  overflow-x:hidden;\n  overflow-y:auto;\n  width:100%;\n  height:100%;\n  position:fixed;\n  left:0;\n  right:0;\n  top:0;\n  bottom:0\n}\n@supports (display:-ms-grid){\n.dash-filters-modal{\n    overflow-y:hidden\n}\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
